const SEPARATORS = ["&", "+"];

// The parameter is optional in practice: a contact, carrier or driver may exist
// with no name. The type said `string` while callers passed `undefined`.
const getNameInitials = (name?: string) => (
  (name || "").split(" ")
    .map(part => part[0])
    .filter(part => part !== undefined && !SEPARATORS.includes(part))
    .filter((_, index) => index < 2)
    .join("")
    .toUpperCase()
);

export default getNameInitials;
